require('./Featured.less');
var FontFaceObserver = require('fontfaceobserver');

var Backbone = require('backbone/backbone');
require('jquery.dotdotdot');

module.exports = Backbone.View.extend({
    events: {
        'mouseenter .Featured-text': 'hoverOn',
        'mouseleave .Featured-text': 'hoverOff'
    },

    initialize: function () {
        this.initTitles();
    },

    initTitles: function () {
        var fontRaleway = new FontFaceObserver('Raleway', {
            weight: 800
        });

        var fontOpenSans = new FontFaceObserver('Open Sans', {
            weight: 400
        });

        Promise.all([fontRaleway.load(), fontOpenSans.load()]).then(function () {
            this.$('.Featured-text').dotdotdot();
            this.$('.Featured-caption').dotdotdot();
        });
    },

    hoverOn: function () {
        this.$el.addClass('Featured--hover');
    },

    hoverOff: function () {
        this.$el.removeClass('Featured--hover');
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/Featured/Featured.js
// module id = 28
// module chunks = 0